import { AccountingPeriod } from '@models/accounting-period';
import { Company } from '@models/company';
import { Contributor } from '@models/contributor';

import { CreationFormalityAbandon, CreationFormalityAbandonJson } from './creation-formality-abandon';
import { CreationFormalityDetail, CreationFormalityDetailJson } from './creation-formality-detail';
import { FormalityBase, FormalityBaseJson } from './formality-base';
import { FormalitySpecificDates } from './formality-specific-dates';
import { LegalFormalityStatus } from './legal-formality-status';
import { FormalityStatusEnum } from '../enums/formality-status.enum';
import { FormalitySupervisorEnum } from '../enums/formality-supervisor.enum';

export interface CreationFormalityJson extends FormalityBaseJson {
  company_creation?: CreationFormalityDetailJson;
  abandon?: CreationFormalityAbandonJson;
}

export class CreationFormality extends FormalityBase {
  constructor(
    public id?: number,
    public formalityType?: string,
    public codeName?: string,
    public status?: string,
    public formalitySupervisor?: FormalitySupervisorEnum,
    public deliveryDate?: Date,
    public statuses?: LegalFormalityStatus[],
    public businessUnitId?: number,
    public production?: Contributor,
    public note?: string,
    public accountingPeriod?: AccountingPeriod,
    public company?: Company,
    public specificDates?: FormalitySpecificDates,
    public creationDetail?: CreationFormalityDetail,
    public abandon?: CreationFormalityAbandon
  ) {
    super(
      id,
      formalityType,
      codeName,
      status,
      formalitySupervisor,
      deliveryDate,
      statuses,
      businessUnitId,
      production,
      note,
      accountingPeriod,
      company,
      specificDates
    );
  }

  get closedOrAbandoned(): boolean {
    return this.status === FormalityStatusEnum.formalityClosed || this.status === FormalityStatusEnum.abandoned;
  }

  static fromJson(json: Partial<CreationFormalityJson>): CreationFormality {
    let creationFormality = new CreationFormality();

    creationFormality = Object.assign(creationFormality, FormalityBase.fromJson(json));

    creationFormality.creationDetail = json.company_creation
      ? CreationFormalityDetail.fromJson(json.company_creation)
      : null;

    creationFormality.abandon = json.abandon ? CreationFormalityAbandon.fromJson(json.abandon) : null;

    return creationFormality;
  }

  static toJson(creationFormality: Partial<CreationFormality>): Partial<CreationFormalityJson> {
    return {
      ...FormalityBase.toJson(creationFormality),

      company_creation: creationFormality.creationDetail
        ? CreationFormalityDetail.toJson(creationFormality.creationDetail)
        : null,

      abandon: creationFormality.abandon ? CreationFormalityAbandon.toJson(creationFormality.abandon) : null
    };
  }
}
